export function ComingSoon({ title, note }: { title: string; note: string }) {
  return (
    <section className="pw-card">
      <h1 style={{ margin: "0 0 0.4rem", fontSize: "1.3rem", fontWeight: 600 }}>{title}</h1>
      <p style={{ margin: 0, fontSize: "0.88rem", color: "var(--pw-color-text-muted)" }}>{note}</p>
    </section>
  );
}
